import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import uniqBy from 'lodash/uniqBy';
import QS from 'qs';
import Base from './base';
import { UserItem, CompanyItem, RoleItem } from '../models';
import { deprecatedWarning } from '../utils/commons';
import { CANCEL_KEYS, DOCS_PRODUCTS } from '../utils/consts';
import * as LocaleUtil from '../utils/locales';
var getConfig = function getConfig(_ref) {
  var cancelToken = _ref.cancelToken,
    config = _ref.config;
  return _extends(_defineProperty({}, CANCEL_KEYS, {
    getter: function getter() {
      return cancelToken;
    },
    setter: function setter(token) {
      return cancelToken = token;
    },
    clearer: function clearer() {
      return cancelToken = undefined;
    }
  }), config);
};

/**
 * `Service` The users service
 */
var User = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function User(sdk) {
    _classCallCheck(this, User);
    return _callSuper(this, User, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(User, _Base);
  return _createClass(User, [{
    key: "getUser",
    value: (
    /**
     * Get a specific user details from HQ API.
     *
     * @param projectId -  the project id
     * @param userId - the user id or oxygen id
     * @param config - Configurable object for overwrite request parameters.
     *
     * @deprecated Please use Admin.getProjectUser instead for ACC product
     */
    function () {
      var _getUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, userId, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.Config.product === DOCS_PRODUCTS.ACC) {
                deprecatedWarning('Users.getUser', 'Admin.getProjectUser');
              }
              _context.next = 3;
              return this.HttpService.adminV1.get("/projects/".concat(projectId, "/users/").concat(userId), config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data ? UserItem.parseHQ(response.data) : null);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUser(_x, _x2, _x3) {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
    /**
     * Get a specific user details from DM API.
     *
     * @param projectId -  the project id
     * @param config - Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "getCurrentUser",
    value: (function () {
      var _getCurrentUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, config) {
        var response, user, _res$data, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.HttpService.dmV1.get("/users/current?project_id=".concat(projectId), config);
            case 2:
              response = _context2.sent;
              if (response.data) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", null);
            case 5:
              user = UserItem.parseV1(response.data); // Try to get id from oxygen identity API
              if (user.analyticsId) {
                _context2.next = 16;
                break;
              }
              _context2.prev = 7;
              _context2.next = 10;
              return this.HttpService.oxygenV1.get('/users/@me/analytics', config);
            case 10:
              res = _context2.sent;
              user.analyticsId = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.analyticsId;
              _context2.next = 16;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](7);
            case 16:
              return _context2.abrupt("return", user);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[7, 14]]);
      }));
      function getCurrentUser(_x4, _x5) {
        return _getCurrentUser.apply(this, arguments);
      }
      return getCurrentUser;
    }()
    /**
     * Search users inside current project.
     *
     * @param projectId -  the project id
     * @param params - query keyword info
     * @param conf - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "searchUsers",
    value: (function () {
      var _searchUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, params, conf) {
        var _this = this;
        var config, query, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              config = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this.searchUserCancelToken;
                },
                setter: function setter(token) {
                  return _this.searchUserCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.searchUserCancelToken = undefined;
                }
              }), conf);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              _context3.next = 4;
              return this.HttpService.dmV1.get("/projects/".concat(projectId, "/combine_search").concat(query), config);
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", {
                users: uniqBy((response.data.users || []).map(UserItem.parseV1), function (_ref2) {
                  var id = _ref2.id;
                  return id;
                }),
                companies: (response.data.companies || []).map(CompanyItem.parseV1),
                roles: (response.data.roles || []).map(RoleItem.parseV1),
                accountUsers: uniqBy((response.data.account_users || []).map(UserItem.parseV1), function (_ref3) {
                  var id = _ref3.id;
                  return id;
                })
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function searchUsers(_x6, _x7, _x8) {
        return _searchUsers.apply(this, arguments);
      }
      return searchUsers;
    }()
    /**
     * Search users through HQ admin APIs.
     * The combine API won't support pagination and will fetch at most 200 records for each inner API
     *
     * https://stoplight.autodesk.com/acs/admin/version%2F1.0/B360-Admin.oas2.yml?view=%2Fusers%2Fgetprojectusers
     * https://stoplight.autodesk.com/acs/admin/version%2F1.0/B360-Admin.oas2.yml?view=%2Froles%2Fgetprojectroles
     * https://stoplight.autodesk.com/acs/admin/version%2F1.0/B360-Admin.oas2.yml?view=%2Fcompanies%2Fgetprojectcompanies
     * https://stoplight.autodesk.com/acs/admin/version%2F1.0/B360-Admin.oas2.yml?view=%2Fusers%2Fgetaccountusers
     *
     * For ACC, it will use construction APIs
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/35b2c4e584406-projects-project-id-users
     *
     * @param projectId -  the project id
     * @param params - query keyword info. With the shape of
     *                        \{
     *                          keyword,            // Search keyword
     *                          locale,             // Target locale, BCP-47
     *                          region,             // Target region, US or EMEA
     *                          limit,              // Return count for each type
     *                          searchAccount,      // Whether search account users, default to false
     *                          searchEveryone,     // Whether search everyone group, default to false
     *                          useConstructionAPI, // Whether search data through ACC admin APIS, default to true
     *                          products,           // The products filter
     *                          accountId           // required when searchAccount is true
     *                        \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns data with the shape of \{
     *                                           projectUsers: \{
     *                                             users: [],
     *                                             pagination: \{ limit, offset, totalResults, hasNext \}
     *                                           \},
     *                                           projectCompanies: \{
     *                                             companies: [],
     *                                             pagination: \{ limit, offset, totalResults, hasNext \}
     *                                           \},
     *                                           projectRoles: \{
     *                                             roles: [],
     *                                             pagination: \{ limit, offset, totalResults, hasNext \}
     *                                           \},
     *                                           accountUsers: \{
     *                                             users: [],
     *                                             pagination: \{ limit, offset, totalResults, hasNext \}
     *                                           \},
     *                                           groups: [\{ id, name \}]
     *                                         \}
     */
    )
  }, {
    key: "combineSearch",
    value: (function () {
      var _combineSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, params, config) {
        var _ref4, keyword, _ref4$locale, locale, _ref4$region, region, _ref4$searchAccount, searchAccount, _ref4$searchEveryone, searchEveryone, _ref4$useConstruction, useConstructionAPI, accountId, _ref4$products, products, _ref4$limit, limit, _ref4$offset, offset, nameOptions, userOptions, requests, _yield$Promise$all, _yield$Promise$all2, projectUsers, projectRoles, projectCompanies, accountUsers, groups, everyOneGroupName, everyOneGroup, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = params || {}, keyword = _ref4.keyword, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? this.Config.locale : _ref4$locale, _ref4$region = _ref4.region, region = _ref4$region === void 0 ? this.Config.region : _ref4$region, _ref4$searchAccount = _ref4.searchAccount, searchAccount = _ref4$searchAccount === void 0 ? false : _ref4$searchAccount, _ref4$searchEveryone = _ref4.searchEveryone, searchEveryone = _ref4$searchEveryone === void 0 ? false : _ref4$searchEveryone, _ref4$useConstruction = _ref4.useConstructionAPI, useConstructionAPI = _ref4$useConstruction === void 0 ? true : _ref4$useConstruction, accountId = _ref4.accountId, _ref4$products = _ref4.products, products = _ref4$products === void 0 ? [] : _ref4$products, _ref4$limit = _ref4.limit, limit = _ref4$limit === void 0 ? 200 : _ref4$limit, _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 0 : _ref4$offset; // Validate parameter
              if (!(searchAccount === true && !accountId)) {
                _context4.next = 3;
                break;
              }
              throw new Error('accountId is required to search account user!');
            case 3:
              nameOptions = _extends({
                limit: limit,
                offset: offset
              }, keyword ? {
                'filter[name]': keyword
              } : {});
              userOptions = _extends({
                limit: limit,
                offset: offset
              }, keyword ? {
                'filter[name]': keyword,
                'filter[email]': keyword,
                orFilters: ['name', 'email']
              } : {}, products.length ? {
                'filter[products]': products
              } : {}); // Setup parallel requests
              requests = [];
              if (!useConstructionAPI) {
                requests.push(this.SDK.HQ.getProjectUsers(projectId, _extends({
                  'filter[status]': ['active', 'pending'],
                  'filter[serviceNames]': ['documentManagement'],
                  // Ensure it's from document management users
                  locale: locale,
                  region: region
                }, userOptions), getConfig({
                  cancelToken: this.combineSearchUserCancelToken,
                  config: config
                })));
              } else {
                requests.push(this.SDK.Admin.getProjectUsers(projectId, _extends({
                  'filter[status]': ['active', 'pending'],
                  locale: locale,
                  region: region
                }, userOptions), getConfig({
                  cancelToken: this.combineSearchUserCancelToken,
                  config: config
                })));
              }
              requests.push(this.SDK.HQ.getProjectRoles(projectId, _extends({
                'filter[status]': ['active'],
                locale: locale,
                region: region
              }, nameOptions), getConfig({
                cancelToken: this.combineSearchRoleCancelToken,
                config: config
              })));
              requests.push(this.SDK.HQ.getProjectCompanies(projectId, _extends({
                locale: locale,
                region: region
              }, nameOptions), getConfig({
                cancelToken: this.combineSearchCompanyCancelToken,
                config: config
              })));
              if (searchAccount && accountId) {
                requests.push(this.SDK.HQ.getAccountUsers(accountId, _extends({
                  'filter[status]': ['active', 'pending', 'not_invited'],
                  locale: locale,
                  region: region
                }, userOptions), getConfig({
                  cancelToken: this.combineSearchAccountUserCancelToken,
                  config: config
                })));
              }
              _context4.next = 12;
              return Promise.all(requests);
            case 12:
              _yield$Promise$all = _context4.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
              projectUsers = _yield$Promise$all2[0];
              projectRoles = _yield$Promise$all2[1];
              projectCompanies = _yield$Promise$all2[2];
              accountUsers = _yield$Promise$all2[3];
              groups = [];
              if (offset === 0 && searchEveryone) {
                everyOneGroupName = LocaleUtil.translate('permissions.everyone');
                if (!keyword || everyOneGroupName.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())) {
                  everyOneGroup = {
                    id: projectId,
                    name: everyOneGroupName
                  };
                  groups.push(everyOneGroup);
                }
              }
              data = {
                projectUsers: projectUsers,
                projectCompanies: projectCompanies,
                projectRoles: projectRoles
              };
              if (searchAccount && accountId) data.accountUsers = accountUsers;
              if (searchEveryone) data.groups = groups;
              return _context4.abrupt("return", data);
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function combineSearch(_x9, _x10, _x11) {
        return _combineSearch.apply(this, arguments);
      }
      return combineSearch;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Users';
    }
  }]);
}(Base);
export default User;